<template>
  <aside
    class="flex items-center gap-2 rounded-sm bg-primary-50 px-7 py-2 text-primary-950"
  >
    <app-icon icon="ph:lock-simple" :size="20" />
    <div class="text-sm">
      <p
        class="inline"
        v-html="$t('course.page.privatization.know_more_label')"
      />
      <app-button
        class="ml-1 !text-primary-950"
        size="small"
        target="_blank"
        to="/enterprise"
        variant="link"
      >
        {{ $t("app.cta.know_more") }}
      </app-button>
    </div>
  </aside>
</template>
